<div class="fundo" role="dialog" aria-modal="true" aria-label="Cancelar agendamento">
  <div class="modal estreito">
    <div class="modal-cab">
      <div class="cab-ico perigo" aria-hidden="true"><svg class="i" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="m9 9 6 6M15 9l-6 6" /></svg></div>
      <div class="cab-txt">
        <b>Cancelar agendamento</b>
        <span>{{ linhas.length }} selecionado{{ linhas.length > 1 ? 's' : '' }}</span>
      </div>
      <button type="button" class="btn-ico fechar-modal" title="Fechar" (click)="cancelar()" [disabled]="salvando">
        <svg class="i" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>

    <div class="modal-corpo" *ngIf="!resultados">
      <div class="mini-wrap">
        <table class="mini">
          <thead><tr><th>Hora</th><th>Paciente</th><th>Status</th><th>Situação</th></tr></thead>
          <tbody>
            <tr *ngFor="let l of linhas">
              <td><b>{{ l.hrInicio }}</b> <span class="selo warn" *ngIf="l.ieEncaixe === 'S'">ENC</span></td>
              <td>{{ l.paciente.nmPaciente || '—' }}</td>
              <td><span class="selo cinza">{{ l.dsStatusAgenda || l.ieStatusAgenda }}</span></td>
              <td>
                <span class="selo bad" *ngIf="motivoIgnorado(l) as m; else vai">não pode: {{ m }}</span>
                <ng-template #vai><span class="selo ok">será cancelado</span></ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="campo" [class.erro]="tentou && semMotivo">
        <label for="cMot">Motivo do cancelamento <span class="req">*</span></label>
        <textarea
          id="cMot"
          rows="3"
          [maxlength]="motivoMax"
          placeholder="Informe o motivo do cancelamento..."
          [(ngModel)]="motivo"
          [disabled]="!aptas.length"
        ></textarea>
      </div>

      <div class="alerta info">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M20 11a8 8 0 0 0-14.6-4.5L4 8M4 4v4h4M4 13a8 8 0 0 0 14.6 4.5L20 16M20 20v-4h-4" /></svg>
        <div><b>Regeração do horário:</b> a linha não é apagada; ela fica com status Cancelada (visível com "Exibir cancelados") e, logo depois, o horário é gerado de novo e volta <b>livre</b> na grade.</div>
      </div>
    </div>

    <div class="modal-corpo" *ngIf="resultados">
      <div class="alerta" [class.ok]="!salvando && !erroCount" [class.warn]="salvando || erroCount" role="status">
        <svg class="i sm" viewBox="0 0 24 24"><path d="m5 12 5 5 9-10" /></svg>
        <div *ngIf="salvando">Cancelando... {{ resultados.length }} de {{ aptas.length }}.</div>
        <div *ngIf="!salvando">
          <b>{{ okCount }}</b> cancelado{{ okCount === 1 ? '' : 's' }}<ng-container *ngIf="erroCount">, <b>{{ erroCount }}</b> com erro</ng-container><ng-container *ngIf="ignorados.length">, {{ ignorados.length }} ignorado{{ ignorados.length > 1 ? 's' : '' }}</ng-container>. A grade foi atualizada.
        </div>
      </div>
      <div class="mini-wrap alto">
        <table class="mini">
          <thead><tr><th>Hora</th><th>Paciente</th><th>Resultado</th></tr></thead>
          <tbody>
            <tr *ngFor="let r of resultados">
              <td><b>{{ r.linha.hrInicio }}</b></td>
              <td>{{ r.linha.paciente.nmPaciente || '—' }}</td>
              <td>
                <div class="item" [class.s-erro]="!r.ok">
                  <span class="selo" [class.ok]="r.ok" [class.bad]="!r.ok">{{ r.ok ? 'Cancelado ✓' : 'Erro ✗' }}</span>
                  <span class="msg-item">{{ r.mensagem }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-rod">
      <ng-container *ngIf="!resultados">
        <span class="msg" *ngIf="tentou && semMotivo">Informe o motivo do cancelamento.</span>
        <button type="button" class="btn btn-contorno" (click)="cancelar()">Voltar</button>
        <button type="button" class="btn btn-perigo" (click)="confirmar()" [disabled]="!aptas.length">
          <svg class="i sm" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
          Cancelar {{ aptas.length }} agendamento{{ aptas.length === 1 ? '' : 's' }}
        </button>
      </ng-container>
      <button *ngIf="resultados" type="button" class="btn btn-primario" (click)="cancelar()" [disabled]="salvando">
        {{ salvando ? 'Cancelando...' : 'Fechar' }}
      </button>
    </div>
  </div>
</div>
